import React from "react";
import css from "./index.css";
import Input from "../../../share/Input";

export default class dotInfo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {companyName, legalName, phone, mc, dot, authority} = this.props.info;
    return (
      <div>
        <div className={css.title}>Is this You?</div>
        <div className={css.form}>
          <Input
            mods={["floatLef", "half"]}
            title={"Company Name"}
            label={"companyName"}
            readOnly={true}
            type="text"
            defaultValue={companyName}
          />
          <Input
            mods={["floatRigt", "half"]}
            title={"Legal Name"}
            label={"legalname"}
            readOnly={true}
            type="text"
            defaultValue={legalName}
          />
          <Input
            mods={["floatLef", "half"]}
            title={"Phone"}
            label={"phone"}
            readOnly={true}
            type="text"
            defaultValue={phone}
          />
          <Input
            mods={["floatRigt", "half"]}
            title={"MC#"}
            label={"mc"}
            readOnly={true}
            type="text"
            defaultValue={mc}
          />
          <Input
            mods={["floatLef", "half"]}
            title={"DOT#"}
            label={"dot"}
            readOnly={true}
            type="text"
            defaultValue={dot}
          />
          <Input
            mods={["floatRigt", "half"]}
            title={"Authority"}
            label={"authority"}
            readOnly={true}
            type="text"
            defaultValue={authority}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/BidVerfiy/component/dot-info/index.js